import { render, staticRenderFns } from "./player-statistic-panel.vue?vue&type=template&id=f8a44c0e&"
import script from "./player-statistic-panel.vue?vue&type=script&lang=js&"
export * from "./player-statistic-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports